import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import StudentsPage from './StudentsPage'
import TeachersPage from './TeachersPage'
import Applications from './Applications'
import AccountDocs from './AccountDocs'
import Directory from './Directory'
import Accepter from './Accepter'
import CheckEDS from './Checkeds'
import { appName } from '../../Service/http'

export default function AdminIndexPage() {
	return (
		<div className='LayoutPage'>
			<Routes>
				<Route path={`/${appName}/`} element={<StudentsPage />} />
				<Route path={`/${appName}/students`} element={<StudentsPage />} />
				<Route path={`/${appName}/teachers`} element={<TeachersPage />} />
				<Route path={`/${appName}/applications`} element={<Applications />} />
				<Route path={`/${appName}/registration`} element={<AccountDocs />} />
				<Route path={`/${appName}/directory`} element={<Directory />} />
				<Route path={`/${appName}/accepter`} element={<Accepter />} />
				<Route path={`/${appName}/check_eds`} element={<CheckEDS/>}/>
			</Routes>
			<Outlet />
		</div>
	)
}
